import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
const FerrySingleBanner = {

    init() {
        if ($('.ferrySingleBanner').length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        new Swiper($('.ferrySingleBanner')[0], {
            autoplay: false,
            //  {
            //     delay:5000,
            //     disableOnInteraction: false,
            //     pauseOnMouseEnter: true,
            // },    
            speed: 500,
            // pauseOnMouseEnter: {
            //     disableOnInteraction: false,
            // },
            pagination: {
                el: '.swiper-pagination',
                clickable: 'true',
            },
            modules: [Navigation, Pagination,Autoplay],
        });
    },
  
}
export default FerrySingleBanner;



// WEBPACK FOOTER //
// ./scripts/modules/components/_ferry-single-banner.js